import {
	IVideosState,
	EVideosActionTypes,
	TVideosActions,
	EGroupPrivacy,
} from "models";

const initial: IVideosState = {
	loading: false,
	path: [],
	data: undefined,
	selectedTags: [],
	query: "",
	redirectQuery: '',
	currentFolder: undefined,
	order: "latest",
	order_dir: "desc",
	meta: {
		pagination: {
			current_page: 0,
			per_page: 0,
			total_pages: 0,
			total_objects: 0,
			has_next_page: true,
		},
		scope_group: {
			id: 0,
			name: "",
			description: "",
			privacy: EGroupPrivacy.closed,
		},
		folders: null,
	},
};

export function videosReducer(
	state = initial,
	action: TVideosActions,
): IVideosState {
	switch (action.type) {
		case EVideosActionTypes.videosLoadingSet: {
			return {
				...state,
				loading: action.payload,
			};
		}
		case EVideosActionTypes.setVideosOrder: {
			return {
				...state,
				order: action.payload[0],
				order_dir: action.payload[1],
			};
		}
		case EVideosActionTypes.setVideos: {
			const { data, reset } = action.payload;
			const videos = reset
				? data.videos
				: state?.data
					? [...state.data].concat(data.videos)
					: data.videos;

			return {
				...state,
				data: videos,
				meta: action.payload.data.meta,
			};
		}
		case EVideosActionTypes.setFilterTagsInStore: {
			const query = !action.payload.parsedTags.length ? "" : state.query;
			return {
				...state,
				selectedTags: action.payload.parsedTags,
				query,
			};
		}
		case EVideosActionTypes.setVideosQuery: {

			return {
				...state,
				query: action.payload?.query,
				selectedTags: [],
			};
		}
		case EVideosActionTypes.setRedirectQuery: {

			return {
				...state,
				redirectQuery: action.payload.redirectQuery,
				selectedTags: [],
			};
		}
		case EVideosActionTypes.incrementVideoViews: {
			return {
				...state,
			};
		}
		case EVideosActionTypes.updateVideosCurrentFolder: {
			return {
				...state,
				currentFolder: action.payload,
			};
		}
		case EVideosActionTypes.setPath: {
			const { index, path, item } = action.payload;
			let data: any = [];
			if (path) {
				data = path;
			} else if (index !== null && typeof index !== "undefined") {
				data = [...state.path].filter((_, i: number) => i <= index);
			} else if (item) {
				data = [...state.path].concat([item]);
			}

			return {
				...state,
				path: data,
			};
		}
		default:
			return state;
	}
}
